export const LISTE_TAG = {
  title: 'Liste des tags',
  breadcrumb: {
    parametrage: 'Paramétrage',
    liste: 'Liste des tags',
  },
  actions: {
    add: 'Ajouter un tag',
    tagArchive: 'Afficher les tags archivés ({nbre})',
    masquerTagArchiver: 'Masquer les tags archivés ({nbre})',
  },
  tab: {
    libelle: 'Libellé',
    moduleTag: 'Module tag',
  },
  popUpArchivage: {
    titleArchiver: 'Êtes-vous sûr de vouloir archiver cet tag ?',
    titleDesarchiver: 'Êtes-vous sûr de vouloir désarchiver cet tag ?',
  },
  messages: {
    success: {
      archiver: 'Tag archivé avec succès.',
      desarchiver: 'Tag désarchivé avec succès.',
    },
  },
};

export const ADD_TAG = {
  titleAdd: 'Ajouter un tag',
  titleEdit: 'Modifier un tag',
  information: {
    libelle: 'Libellé',
    moduleTag: 'Module tag',
    color: 'Couleur',
  },
  success: {
    add: 'Le tag a été ajouté avec succès.',
    edit: 'Le tag a été modifié avec succès.',
  },
  moduleTags: {
    campagne: 'Campagne',
    dispositif: 'Dispositif',
    demandeImpression: 'Demande d\'impression',
    demandeIntervention: 'Demande d\'intervention',
    documentVente: 'Document vente',
    sousReseau: 'Sous réseau',
    client: 'Client',
  },
  error: {
    libelle: 'Libellé',
    moduleTag: 'Module tag',
  },
};
